export default "__VITE_ASSET__xpk9PnyF__"